import React from 'react';
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import WebFont from 'webfontloader';
import {
  ThemeFieldWrapper,
  ThemesWrapper,
} from './styledComponents';
import { AppPreview, PhotoFilterPreview } from './components';

export const ThemeField = ({
  value,
  appPreview,
  filterPreview,
  selected,
  theme,
  themeInstance,
  backgroundColor,
  isField,
  onThemeSelect
}) => {
  WebFont.load({
    google: {
      families: [theme.font]
    },
    fontinactive: (familyName, _fvd) => {
      WebFont.load({
        typekit: {
          id: familyName,
        }
      });
    }
  });
  return (
  <ThemeFieldWrapper selected={selected}>
    <AppPreview
      shrink
      firstLineFieldName={selected && 'first_line_font_shrink'}
      secondLineFieldName={selected && 'second_line_font_shrink'}
      selectedTheme={theme}
      themeInstance={themeInstance}
      backgroundColor={backgroundColor}
    />
    <PhotoFilterPreview
      small
      selectedTheme={theme}
      themeInstance={themeInstance}
    />
    { isField &&
      <Field
        name='channel_theme_id'
        component={({ input, type }) =>
          <input
            {...input}
            onChange={(e) =>{
                var return_fn =
                  (input.value
                  ? input.onChange(e)
                    : input.onChange(null))
                  onThemeSelect()
                  return return_fn


            }}
            type={type}
          />
        }
        value={value}
        type='radio'
      />
    }
  </ThemeFieldWrapper>
);}

const PhotographerThemeForm = (props) => {
  const {
    themeId,
    setThemeIdFunction,
    channelThemes,
    themeInstanceId,
    channelThemeInstances,
    backgroundColor,
    nextTab,
    isNew,
    setDefaultColor
  } = props;
  const themeInstance = isNew? null : channelThemeInstances[themeInstanceId];
  return (
    <ThemesWrapper>
      { !!channelThemes && Object.keys(channelThemes).map(k =>
          <ThemeField
            isField
            key={k}
            value={k}
            theme={channelThemes[k]}
            selected={(themeId && themeId.toString()) === k}
            themeInstance={themeInstance}
            backgroundColor={backgroundColor}
            onThemeSelect={(theme) => {
              if(backgroundColor === '' || !backgroundColor) {
                if(isNew){
                  setThemeIdFunction(channelThemes[k].id)
                }
                setDefaultColor(channelThemes[k].default_app_background_color)
              }
              nextTab();
            }}
          />
        )
      }
    </ThemesWrapper>
  );
}

export default connect(null, {
  setDefaultColor: (color) => change( "channelForm", "background", color),
})(PhotographerThemeForm)



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/PhotographerThemeForm.js